import { render } from "./CountNumberFixer.vue?vue&type=template&id=7f99d1b8&scoped=true"
import script from "./CountNumberFixer.vue?vue&type=script&lang=js"
export * from "./CountNumberFixer.vue?vue&type=script&lang=js"

import "./CountNumberFixer.vue?vue&type=style&index=0&id=7f99d1b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f99d1b8"]])

export default __exports__